<template>
  <div>
    <e-header/>
    <e-swiper/>
    <e-body1/>
    <e-body2/>
    <e-body3/>
    <e-body4/>
    <e-footer/>
  </div>
</template>

<script>
import EHeader from "../components/e-header.vue";
import EFooter from "../components/e-footer.vue";
import EBody1 from "../components/index/e-body1.vue";
import EBody2 from "../components/index/e-body2.vue";
import EBody3 from "../components/index/e-body3.vue";
import EBody4 from "../components/index/e-body4.vue";
import ESwiper from "../components/index/e-swiper.vue";
export default {
  name: 'app',
  components:{
    EHeader,EBody1,EBody2,EBody3,EBody4,ESwiper,EFooter
  },
  data () {
    return {
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/index.vue